
import "D:/Projects/Aimer/AimerPay/src/components/BackToMerchantListMenuItem/index.less?modules";
export default {"item": `item-0GLDhl3G`,"icon": `icon-3WiF9BmC`}
